import { gql } from '@apollo/client'

export const GET_CHARTS_BY_NAME = gql`
  query ($type: ChartNameTypeParameter!, $name: String!) {
    getChartsByName(type: $type, name: $name) {
      artist
      title
    }
  }
`
